import { format } from "date-fns";
import * as React from "react";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import { DateFormat } from "constants/date";
import { formatPrice } from "helpers/subscription";
import { IRecurlyCoupon } from "store/entities/recurly";
import { RecurlyCouponDuration } from "store/entities/recurly/interfaces";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

interface IProps {
  nonViewersCount: number;
  price: number;
  coupon: IRecurlyCoupon | null;
  expirationDate: Date;
  isCanceled: boolean;
  isTaxed: boolean;
}

export const PhaseTrialCC: React.FC<IProps> = ({
  nonViewersCount,
  price,
  expirationDate,
  coupon,
  isCanceled,
  isTaxed,
}) => {
  const formattedExpirationDate = format(expirationDate, DateFormat.DateStartedFromMonth);
  return (
    <>
      {isCanceled && (
        <Text customColor={withVar(DesignToken.ActionNegativeDefault)}>
          Your trial will be canceled on <strong>{formattedExpirationDate}</strong>.
        </Text>
      )}
      {!isCanceled && (
        <Text customColor={withVar(DesignToken.ActionPositiveDefault)}>
          Your first charge of{" "}
          <strong>
            {formatPrice(price)}
            {isTaxed && " + applicable tax"}
          </strong>
          {" is due on "}
          <strong>{formattedExpirationDate}</strong>.
        </Text>
      )}
      {coupon && coupon.duration === RecurlyCouponDuration.SingleUse && (
        <Text>
          The coupon “<strong>{coupon.code}</strong>” is now added to your subscription and will be applied for your
          first payment.
        </Text>
      )}
      <Text>
        You have{" "}
        <strong>
          {nonViewersCount} paid {plural(nonViewersCount, "user", "users")}
        </strong>{" "}
        in HelpDesk.
      </Text>
    </>
  );
};
